// extracted by mini-css-extract-plugin
export default {"wrap":"Select_wrap__3tXBS"};